import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from 'Components';
import './PickHead.css';

const PickHead = props => (
  <div className="pick-head">
    <CheckBox checked={props.checked} onClick={props.onClick} />
    <span>Select All</span>
  </div>);

PickHead.propTypes = {
  onClick: PropTypes.func,
  checked: PropTypes.bool,
};

PickHead.defaultProps = {
  checked: false,
};

export default PickHead;



// WEBPACK FOOTER //
// ./src/components/PickHead/PickHead.jsx